import { render } from "./ErrorScreen.vue?vue&type=template&id=55b9c7e3&ts=true"
import script from "./ErrorScreen.ts?vue&type=script&lang=ts"
export * from "./ErrorScreen.ts?vue&type=script&lang=ts"

import "./ErrorScreen.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__